/**
 * Video.js plugin "socialShare"
 *
 * The plugin adds social share link options.
 *
 * @function socialShare
 * @param
 */

const pluginSocialShare = videojs => {
  videojs.addLanguage('de', {
    'Social Share on': 'Teilen-Optionen anzeigen',
    'Social Share off': 'Teilen-Optionen ausblenden',
  });

  videojs.registerPlugin('socialShare', function (player, config) {
    player.ready(() => {
      // Prevent doubled rendering
      if (player.el_.querySelector('.vjs-social-share')) return;

      // Return if no social share data is present.
      if (!player.el_.dataset || !player.el_.dataset.socialShare) return;

      const socialShareInfo = player.el_.dataset.socialShare;
      const itemsData = JSON.parse(socialShareInfo);
      let isActive = !config.socialShareInControlbar;
      let controlBarButton;

      const createControlbarButton = () => {
        controlBarButton = player.controlBar.addChild('button');
        controlBarButton.controlText(player.localize('Social Share on'));
        controlBarButton.el_.classList.add('vjs-social-share-control');

        controlBarButton.on('click', toggleSocialShare);
        controlBarButton.on('touchend', toggleSocialShare);
        controlBarButton.on('keydown', buttonFocusHandler);
      };

      const toggleSocialShare = () => {
        isActive = !isActive;

        if (!isActive) {
          controlBarButton.controlText(player.localize('Social Share on'));
          controlBarButton.el_.classList.remove('vjs-social-share-control--on');
          socialShareList.classList.remove('vjs-social-share--visible');
          return;
        }

        controlBarButton.controlText(player.localize('Social Share off'));
        controlBarButton.el_.classList.add('vjs-social-share-control--on');
        socialShareList.classList.add('vjs-social-share--visible');
      };

      const createTemplate = () => {
        // Return if object in `data-social-share` is empty.
        if (Object.keys(socialShareInfo).length === 0) return;

        const template = document.createRange().createContextualFragment(`
          <div class="vjs-social-share ${
            config.socialShareInControlbar ? 'vjs-social-share--has-toggle' : ''
          }">
              <ul class="vjs-social-share__list">
                  ${createItemsTemplate()}
              </ul>         
          </div>
        `).children[0];

        // Event binding
        if (!config.socialShareInControlbar) return template;
        template.addEventListener('focusout', listFocusHandler);
        player.on('dispose', () => {
          template.removeEventListener('focusout', listFocusHandler);
        });

        return template;
      };

      const createItemsTemplate = () => {
        let itemsTemplate = '';

        for (const item in itemsData) {
          const url = itemsData[item].url;
          const label = itemsData[item].label;
          const labelHidden = itemsData[item].labelHidden;
          const icon = itemsData[item].icon;

          if (url) {
            itemsTemplate += `
              <li class="vjs-social-share__item">
                <a 
                class="vjs-social-share__link"
                ${labelHidden ? `title="${label}"` : ''} 
                href="${url}" target="_blank">
                  ${
                    icon
                      ? `<span class="vjs-social-share__icon">${icon}</span>`
                      : ''
                  } 
                  <span class="vjs-social-share__label" 
                  ${labelHidden ? 'aria-hidden="true"' : ''}>
                    ${label}
                  </span>
                </a>                  
              </li>
            `;
          }
        }
        return itemsTemplate;
      };

      // Focus

      const listFocusHandler = e => {
        if (!socialShareList.contains(e.relatedTarget)) {
          controlBarButton.el_.focus();
        }
      };

      const buttonFocusHandler = e => {
        if (isActive && e.key === 'Tab') {
          setTimeout(() => {
            if (e.shiftKey) {
              lastItem.focus();
              return;
            }
            firstItem.focus();
          }, 0);
        }
      };

      // Render to DOM

      const socialShareList = createTemplate();
      const items = socialShareList.querySelectorAll('.vjs-social-share__item');
      const firstItem = items[0].querySelector('a, button');
      const lastItem = items[items.length - 1].querySelector('a, button');
      player.el_.appendChild(socialShareList);

      if (config.socialShareInControlbar) createControlbarButton();
    });
  });
};

export { pluginSocialShare };
